import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { clsx } from 'clsx';
import { Panel } from '@/components/Panel';

/** Briques des pages de détail (dashboards) : valeur de l'en-tête, encadré, badge de statut */

/** Valeur de l'en-tête (libellé au-dessus) */
export function Value({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <dt className="text-xs font-medium text-slate-500">{label}</dt>
      <dd className="mt-1 text-sm text-slate-900 break-all">{children}</dd>
    </div>
  );
}

/** Encadré avec titre, icône, action à droite et message quand il est vide */
export function Box({
  title,
  icon: Icon,
  empty,
  action,
  className,
  children,
}: {
  title: string;
  icon: LucideIcon;
  /** Bouton à droite du titre */
  action?: ReactNode;
  /** Message affiché à la place du contenu quand la liste est vide (false : contenu affiché) */
  empty: string | false;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Panel as="section" className={className} aria-label={title}>
      <div className="px-6 py-3 border-b border-slate-200 flex items-center justify-between gap-4 min-h-14">
        <h3 className="flex items-center gap-2 font-semibold text-slate-900">
          <Icon className="w-4 h-4 text-slate-400" />
          {title}
        </h3>
        {action}
      </div>
      <div className="px-6 py-2">{empty ? <p className="py-3 text-sm text-slate-500">{empty}</p> : children}</div>
    </Panel>
  );
}

/** Badge Actif / Inactif */
export function StatusBadge({ enabled, label }: { enabled: boolean; label?: string }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        enabled ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200',
      )}
    >
      <span className={clsx('w-1.5 h-1.5 rounded-full mr-1.5', enabled ? 'bg-green-600' : 'bg-red-600')} />
      {label ?? (enabled ? 'Actif' : 'Inactif')}
    </span>
  );
}
